exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh3[data-v-2b8ccf22], h4[data-v-2b8ccf22], h5[data-v-2b8ccf22] {\n  margin-bottom: 10px;\n}\n", ""]);

// exports
